/* Prime Outlet · carrito (v13.9): Vistos recientemente en la página del carrito (una sola fila con flechas) y, en el inicio, justo debajo de Promociones · Cómputo.
   NO modifica el carrito flotante. Usa la lista que guarda po-busqueda-vistos.js (po_vistos_v1). */
(function () {
  if (window.__poCarrito) return; window.__poCarrito = true;
  var CLAVE = 'po_vistos_v1';
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  function leer() { try { return JSON.parse(localStorage.getItem(CLAVE)) || []; } catch (e) { return []; } }
  function esc(t) { var d = document.createElement('div'); d.textContent = t == null ? '' : String(t); return d.innerHTML; }
  function soles(c) { return 'S/ ' + (c / 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }); }
  function foto(u, w) { if (!u) return ''; if (u.indexOf('//') === 0) u = 'https:' + u; return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; }
  var cache = {};
  function prod(h) { if (!cache[h]) cache[h] = fetch(root + 'products/' + encodeURIComponent(h) + '.js').then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; }); return cache[h]; }
  function variante(p) { return (p.variants || []).filter(function (v) { return v.available; })[0] || null; }

  var css = document.createElement('style');
  css.textContent =
    '.po-vc{max-width:var(--page-width,140rem);margin:0 auto;padding:2.4rem 1.5rem 4rem;font-family:"DM Sans",sans-serif}' +
    '@media(min-width:750px){.po-vc{padding:2.4rem 5rem 4rem}}' +
    '.po-vc h2{margin:0 0 1.4rem;font-size:2rem;font-weight:600;color:#2E2E2E;text-align:center}' +
    '.po-vc__w{position:relative}' +
    '.po-vc__g{display:grid;grid-auto-flow:column;grid-auto-columns:calc((100% - 3*1.4rem)/4);gap:1.4rem;overflow-x:auto;scroll-snap-type:x mandatory;scrollbar-width:none;padding:2px}' +
    '.po-vc__g::-webkit-scrollbar{display:none}' +
    '@media(max-width:989px){.po-vc__g{grid-auto-columns:calc((100% - 1.4rem)/2.3)}}' +
    '.po-vc__c{scroll-snap-align:start;border:1px solid #ECECEC;border-radius:14px;background:#fff;padding:1.2rem;display:flex;flex-direction:column;gap:.8rem}' +
    '.po-vc__c img{width:100%;aspect-ratio:1/1;object-fit:contain;background:#fff;mix-blend-mode:multiply;border-radius:10px}' +
    '.po-vc__c a{font-size:1.4rem;line-height:1.4;color:#2E2E2E;text-decoration:none;min-height:2.8em;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden}' +
    '.po-vc__c b{color:#E53935;font-size:1.7rem;font-weight:600}' +
    '.po-vc__c button.po-vc__add{align-self:flex-start;background:#FFD814;color:#2E2E2E;border:0;border-radius:999px;font-size:1.2rem;font-weight:600;padding:1rem 1.4rem;min-height:3.6rem;cursor:pointer;margin-top:auto}' +
    '.po-vc__c button.po-vc__add:hover{background:#F7CA00}' +
    '.po-vc__n{position:absolute;top:38%;width:4rem;height:4rem;border-radius:50%;border:1px solid #ddd;background:#fff;box-shadow:0 2px 6px rgba(0,0,0,.12);font-size:2rem;line-height:1;color:#565959;cursor:pointer;padding:0}' +
    '.po-vc__n--i{left:-1.6rem}.po-vc__n--d{right:-1.6rem}' +
    '@media(max-width:749px){.po-vc__n{display:none}}';
  document.head.appendChild(css);

  document.addEventListener('click', function (e) {
    var n = e.target.closest('.po-vc__n');
    if (n) { var g = n.parentElement.querySelector('.po-vc__g'); g.scrollBy({ left: (n.classList.contains('po-vc__n--i') ? -1 : 1) * g.clientWidth * 0.9, behavior: 'smooth' }); return; }
    var b = e.target.closest('[data-po-add]');
    if (!b) return;
    e.preventDefault();
    b.disabled = true;
    fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: parseInt(b.getAttribute('data-po-add'), 10), quantity: 1 }) })
      .then(function () { location.reload(); }).catch(function () { b.disabled = false; });
  });

  function paginaVistos() {
    if (!/\/cart\/?$/.test(location.pathname) || document.querySelector('.po-vc')) return;
    var main = document.querySelector('main#MainContent, main');
    if (!main) return;
    Promise.all(leer().slice(0, 12).map(prod)).then(function (ps) {
      ps = ps.filter(Boolean);
      if (!ps.length || document.querySelector('.po-vc')) return;
      var s = document.createElement('section');
      s.className = 'po-vc';
      s.innerHTML = '<h2>Vistos recientemente</h2><div class="po-vc__w"><div class="po-vc__g">' + ps.map(function (p) {
        var v = variante(p);
        return '<div class="po-vc__c"><img src="' + foto(p.featured_image, 400) + '" alt="" loading="lazy"><a href="' + root + 'products/' + p.handle + '">' + esc(p.title) + '</a><b>' + soles(v ? v.price : p.price) + '</b>' +
          (v ? '<button type="button" class="po-vc__add" data-po-add="' + v.id + '">+ Agregar al carrito</button>' : '') + '</div>';
      }).join('') + '</div><button type="button" class="po-vc__n po-vc__n--i" aria-label="Anterior">‹</button><button type="button" class="po-vc__n po-vc__n--d" aria-label="Siguiente">›</button></div>';
      main.appendChild(s);
    });
  }

  function moverInicio() {
    var v = document.querySelector('main .po-vistos');
    var promo = document.querySelector('main [id$="__promo_tabs"]');
    if (!v || !promo || promo.nextElementSibling === v) return;
    promo.insertAdjacentElement('afterend', v);
  }

  var t = null;
  new MutationObserver(function () { clearTimeout(t); t = setTimeout(moverInicio, 150); }).observe(document.documentElement, { childList: true, subtree: true });
  function init() { moverInicio(); paginaVistos(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
